import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { CheckoutOrderState } from '@x/ecommerce-shop/app/checkout/state/checkout-order.state';
import { ShopOrderState } from '@x/ecommerce-shop/app/core/order/state/shop-order.state';
import { ShopPillComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-pill/shop-pill.component';
import { map, merge } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'x-order-shipment-name',
  standalone: true,
  imports: [ShopPillComponent, AsyncPipe],
  templateUrl: './order-shipment-name.component.html',
  styleUrl: './order-shipment-name.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderShipmentNameComponent {
  shipmentName$ = merge(
    this.store.select(ShopOrderState.order),
    this.store.select(CheckoutOrderState.order),
  ).pipe(
    filter(Boolean),
    map((order) => order?.shipment?.methodName),
  );

  constructor(private store: Store) {}
}
